import { gql } from "@apollo/client";

export const GET_ALL_INSTITUCIONES = gql`
query GetAllInstituciones(
    $skip: Int 
    $take: Int
    $where: t_institucionNoSAPFilterInput
) {
    allInstitucionesPaginated(
        skip: $skip
        take: $take
        where: $where
    ) {
        items {
            cod_Institucion
            nombre
            iddelegacion
            origen
            nombreFantasia
            domicilio
            activo
            tipoUnidad
            idLocalidad
            idProvincia
            tipoInstitucion
            datosGeneralesRI {
                idPaciente
            }
            idLocalidadNavigation {
                codigoPostal
                descripcion
            }
            idProvinciaNavigation {
                descripcion
            }
        }
            totalCount
    }
}
`;

export const adaptCentro = (centro) => {
  return {
    codigo: centro?.cod_Institucion,
    nombre: centro?.nombre,
    nombreFantasia: centro?.nombreFantasia,
    domicilio: centro?.domicilio
  };
};

export const adaptCentrosArray = (
allInstituciones) =>
{
  return structuredClone(allInstituciones)?.
  map((centro) => adaptCentro(centro));
};

export const adaptInstitucion = (institucion) => {
  return {
    codigo: institucion?.cod_Institucion,
    nombre: institucion?.nombre,
    nombreFantasia: institucion?.nombreFantasia,
    domicilio: institucion?.domicilio,
    direccion: institucion?.domicilio,
    localidad: institucion?.idLocalidadNavigation?.descripcion,
    codigoPostal: institucion?.idLocalidadNavigation?.codigoPostal,
    provincia: institucion?.idProvinciaNavigation?.descripcion
  };
};

export const adaptInstitucionesArray = (
allInstituciones) =>
{
  return structuredClone(allInstituciones)?.
  map((institucion) => adaptInstitucion(institucion));
};